import { NavBar } from "../../Components/NavBar";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MunicipalitiesTable from "./sub/MunicipalitiesTable/MunicipalitiesTable";

const Admin = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/home");
  };

  return (
    <>
      <NavBar />
      <div className="p-4">
        <Box sx={{ mb: 3 }}>
          <div className="flex justify-between">
            <Typography variant="h4" component="h1" gutterBottom>
              Municipality Management
            </Typography>
            <Button
              variant="text"
              startIcon={<ArrowBackIcon />}
              onClick={handleBackToHome}
              sx={{ mb: 2 }}
            >
              Back
            </Button>
          </div>
          <Typography variant="body1" color="text.secondary">
            Review and approve municipality change requests
          </Typography>
        </Box>

        <MunicipalitiesTable />
      </div>
    </>
  );
};

export default Admin;
